import angular from 'angular';

import * as actions from '../../../store/actions';

const mapStateToScope = (state) => ({
  anonymization: state.user.activeAnonymization,
});

/**
 * @ngdoc function
 * @name myConsultApp.controller:anonymizationDetailController
 * @description
 * # anonymizationDetailController
 * Controller of the myConsultApp
 */
angular
  .module('myConsultApp')
  .controller('anonymizationDetailController', ($ngRedux, $scope, $rootScope, $timeout, $http, ENV, $interval) => {
    $scope.init = () => {
      $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);
    };

    $scope.close = () => {
      $rootScope.isAnonymizationDetailDisplay = false;
      $rootScope.closeComponent();
    };

    $scope.generateUserRoute = () => {
      return `${$rootScope.routes.user}/${$scope.user.id}`;
    };

    let anonymizationPromise;
    $scope.pollAnonymizationStatus = () => {
      // if promise exists, cancel it to prevent duplication of intervals
      if (angular.isDefined(anonymizationPromise)) {
        $interval.cancel(anonymizationPromise);
        anonymizationPromise = undefined;
      }
      anonymizationPromise= $interval(() => {
        $scope.getAnonymizationStatus();
      }, 6000);
    }

    $scope.getAnonymizationStatus = () => {
      $scope
      .getAnonymization($http, ENV, $rootScope.userId, $scope.anonymization.id)
      .then((res) => {
        $scope.$apply(() => {
          $scope.checkAnonymizationStatus();
        });
      });
    };

    $scope.checkAnonymizationStatus = () => {
      if (!$scope.anonymization.anonymization_completed){
        $scope.pollAnonymizationStatus();
      } else if ($scope.anonymization.anonymization_completed) {
        $interval.cancel(anonymizationPromise);
        $rootScope.refreshLoyaltyStatistics();
        $rootScope.getData();
        $scope.getUser($http, ENV, $rootScope.userId);
      }
    }

    const userIdListener = $rootScope.$watch('isAnonymizationDetailDisplay', () => {
      if ($rootScope.isAnonymizationDetailDisplay && $rootScope.userId) {
        $scope.checkAnonymizationStatus();
      }
    });

    $scope.init();

    $scope.$on('$destroy', () => {
      $scope.unsubscribe();
      $interval.cancel(anonymizationPromise);
      userIdListener();
    });
  })
  .directive('anonymizationDetail', () => {
    return {
      templateUrl: 'templates/v2/anonymization-detail.html',
    };
  });
